import { CombinedGraphQLErrors, ErrorLike } from "@apollo/client";

export type OidcSubjectTemplateFormFields = {
  template: string;
};

export const DEFAULT_TEMPLATE =
  "space:{spaceId}:{callerType}:{callerId}:run_type:{runType}:scope:{scope}";

export const AVAILABLE_PLACEHOLDERS = [
  "{spaceId}",
  "{spacePath}",
  "{callerType}",
  "{callerId}",
  "{runId}",
  "{runType}",
  "{scope}",
];

const VALIDATION_ERROR_PREFIX = "invalid OIDC subject template: ";

export const extractValidationError = (error: ErrorLike): string | undefined => {
  if (!CombinedGraphQLErrors.is(error)) {
    return undefined;
  }

  const graphqlError = error.errors.find((e) => e.message.includes(VALIDATION_ERROR_PREFIX));

  if (!graphqlError) {
    return undefined;
  }

  return graphqlError.message.replace(VALIDATION_ERROR_PREFIX, "");
};

export const getFormDefaultValues = (
  currentTemplate: string | null | undefined
): OidcSubjectTemplateFormFields => ({
  template: currentTemplate ?? "",
});
